import { useState } from "react"
import { IDptObjResp } from "../interface/department"
import DepartmentFlow from "./department/DepartmentFlow"
import { CreateEditKR } from "../../components/objectives/CreateEditKR"
import { CreateEditDptObj } from "../../components/objectives/CreateEditDptObj"
interface props {
  data: IDptObjResp | undefined
}

interface ModalState {
  type: "add-obj" | "add-kr" | ""
}

const DptObjectivesTab = ({ data }: props) => {
  // const [editCompObj, setEditCompObj] = useState(false)
  const [activeObj, setActiveObj] = useState<number | null>(null)
  // const [showAddIndKR, setShowAddIndKR] = useState(false)
  const [modal, setModal] = useState<ModalState>({
    type: "",
  })

  return (
    <div>
      <DepartmentFlow
        data={data?.data || []}
        setOpenCreatObj={() => {
          setModal({
            type: "add-obj",
          })
        }}
        activeObj={activeObj}
        setActiveObj={setActiveObj}
        KRURL="/api/v2/admin/okr/departmentkeyresults"
        pageType="admin"
        emptyStateText="Set your first Objective"
      />

      <CreateEditDptObj
        open={modal.type === "add-obj"}
        onClose={() => setModal({ type: "" })}
        role="admin"
        deptId={data?.data?.[0]?.departmentId}
      />
      {modal.type === "add-kr" && (
        <CreateEditKR
          onClose={() => {
            setModal({ type: "" })
          }}
          open={modal.type === "add-kr"}
          role={"admin"}
          deptId={data?.data?.[0]?.departmentId}
          deptObjId={activeObj}
        />
      )}
    </div>
  )
}

export default DptObjectivesTab
